import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import ButtonStyles from '@stories/Components/Global/Buttons/Button/Button.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.nav `
  display: contents;
`;
const NavigationMenu = styled(m.div) `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--navigationBgActiveColour);
  position: fixed;
  top: var(--headerHeight);
  left: 0;
  height: calc(100vh - var(--headerHeight));
  height: calc(100dvh - var(--headerHeight));
  width: 100vw;
  overflow: auto;
  padding: 12px 16px 46px;
  z-index: ${Layers.Navigation};

  [data-has-phone='true'] & {
    top: calc(var(--headerHeight) + var(--mobilePhoneNumberHeight));
    height: calc(100vh - var(--headerHeight) - var(--mobilePhoneNumberHeight));
    height: calc(100dvh - var(--headerHeight) - var(--mobilePhoneNumberHeight));
  }

  [data-scroll-active='true'] & {
    top: var(--stickyHeaderHeight);
    height: calc(100vh - var(--stickyHeaderHeight));
    height: calc(100dvh - var(--stickyHeaderHeight));
  }

  @media ${from(Device.TabletLarge)} {
    display: none !important;
  }

  > ${ButtonStyles.Container} {
    margin-top: auto;
    flex: 0 0 ${fluid(44, 46)};
  }
`;
const BackButtton = styled.div `
  padding-top: 16px;

  [data-site='ess'] & {
    ${ButtonStyles.Container} {
      position: relative;
      margin-left: ${fluid(22, 23)};

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: -1px;
        left: -1px;
        width: 22px;
        height: calc(100% + 2px);
        background-color: ${brand.global.red};
        clip-path: polygon(100% 0, 0 50%, 100% 100%);
        transform: translateX(-100%);
      }
    }
  }
`;
const LinkList = styled.ul `
  padding: 32px 0;
  max-width: 300px;
  width: 100%;
`;
const LinkListItem = styled.li `
  ${fonts.daxWide.medium};

  display: block;
  color: var(--navigationFgActiveColour);
  font-size: 16px;
  line-height: 26px;
  width: 100%;

  &[data-label='true'] {
    ${fonts.daxWide.bold};

    text-transform: uppercase;
    margin-bottom: 12px;
  }
`;
const Link = styled.a `
  ${ButtonReset};
  ${fonts.daxWide.medium};

  font-size: 16px;
  line-height: 26px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  color: currentColor;
  width: 100%;

  > svg {
    display: block;
    height: 12px;
  }
`;
const MobileNavigationStyles = {
    BackButtton,
    Container,
    Link,
    LinkList,
    LinkListItem,
    NavigationMenu,
};
export default MobileNavigationStyles;
